"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCreateFolder;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context2 = require("../../context");

/*
  Create Secure Document Folder React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useCreateFolder() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useCreateFolder`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var createFolder = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.createFolder({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createFolder(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [createFolder, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VDcmVhdGVGb2xkZXIvdXNlQ3JlYXRlRm9sZGVyLnRzIl0sIm5hbWVzIjpbInVzZUNyZWF0ZUZvbGRlciIsIm9wdGlvbnMiLCJTZWN1cmVEb2N1bWVudHNQcm92aWRlciIsIkNvbnRleHQiLCJjbGllbnQiLCJFcnJvciIsImxvYWRpbmciLCJzZXRMb2FkaW5nIiwiZXJyb3IiLCJzZXRFcnJvciIsImNyZWF0ZUZvbGRlciIsInBhdGgiLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlcyIsInJlaiIsInRoZW4iLCJyZXNwIiwib25Db21wbGV0ZWQiLCJjYXRjaCIsImVyciIsIm9uRXJyb3IiLCJmaW5hbGx5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFHQTs7QUFJQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ2UsU0FBU0EsZUFBVCxHQUFxRjtBQUFBLE1BQTVEQyxPQUE0RCx1RUFBMUIsRUFBMEI7O0FBQUEsYUFDL0UsdUJBQVdDLGtDQUF3QkMsT0FBbkMsS0FBK0NGLE9BQU8sQ0FBQ0csTUFEd0I7QUFBQSxNQUMxRkEsTUFEMEYsUUFDMUZBLE1BRDBGOztBQUVsRyxNQUFJLENBQUNBLE1BQUwsRUFBYTtBQUNYLFVBQU0sSUFBSUMsS0FBSixDQUFVLDZDQUFWLENBQU47QUFDRDs7QUFKaUcsa0JBTXBFLHFCQUFTLEtBQVQsQ0FOb0U7QUFBQTtBQUFBLE1BTTNGQyxPQU4yRjtBQUFBLE1BTWxGQyxVQU5rRjs7QUFBQSxtQkFPeEUsc0JBUHdFO0FBQUE7QUFBQSxNQU8zRkMsS0FQMkY7QUFBQSxNQU9wRkMsUUFQb0Y7O0FBU2xHLE1BQU1DLFlBQVk7QUFBQSx3RkFBRyxpQkFBT0MsSUFBUDtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsK0NBQ25CQyxPQUFPLENBQUNDLE9BQVIsQ0FDRSxJQUFJRCxPQUFKLENBQVksVUFBQ0UsR0FBRCxFQUFNQyxHQUFOLEVBQWM7QUFDeEJSLGdCQUFBQSxVQUFVLENBQUMsSUFBRCxDQUFWO0FBQ0FILGdCQUFBQSxNQUFNLENBQ0hNLFlBREgsQ0FDZ0I7QUFBRUMsa0JBQUFBLElBQUksRUFBSkE7QUFBRixpQkFEaEIsRUFFR0ssSUFGSCxDQUVRLFVBQUNDLElBQUQsRUFBOEI7QUFBQTs7QUFDbEMsMENBQUFoQixPQUFPLENBQUNpQixXQUFSLG1GQUFBakIsT0FBTyxFQUFlZ0IsSUFBZixDQUFQO0FBQ0FILGtCQUFBQSxHQUFHLENBQUNHLElBQUQsQ0FBSDtBQUNELGlCQUxILEVBTUdFLEtBTkgsQ0FNUyxVQUFDQyxHQUFELEVBQWdCO0FBQUE7O0FBQ3JCWCxrQkFBQUEsUUFBUSxDQUFDVyxHQUFELENBQVI7QUFDQSxzQ0FBQW5CLE9BQU8sQ0FBQ29CLE9BQVIsMkVBQUFwQixPQUFPLEVBQVdtQixHQUFYLENBQVA7QUFDQUwsa0JBQUFBLEdBQUcsQ0FBQ0ssR0FBRCxDQUFIO0FBQ0QsaUJBVkgsRUFXR0UsT0FYSCxDQVdXO0FBQUEseUJBQU1mLFVBQVUsQ0FBQyxLQUFELENBQWhCO0FBQUEsaUJBWFg7QUFZRCxlQWRELENBREYsQ0FEbUI7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FBSDs7QUFBQSxvQkFBWkcsWUFBWTtBQUFBO0FBQUE7QUFBQSxLQUFsQjs7QUFtQkEsU0FBTyxDQUFDQSxZQUFELEVBQWU7QUFBRU4sSUFBQUEsTUFBTSxFQUFOQSxNQUFGO0FBQVVJLElBQUFBLEtBQUssRUFBTEEsS0FBVjtBQUFpQkYsSUFBQUEsT0FBTyxFQUFQQTtBQUFqQixHQUFmLENBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQsIHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ3JlYXRlRm9sZGVyT3V0cHV0IH0gZnJvbSAnLi4vLi4vLi4vY29yZSc7XG5cbmltcG9ydCB7IFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIH0gZnJvbSAnLi4vLi4vY29udGV4dCc7XG5cbmltcG9ydCB7IFVzZUNyZWF0ZUZvbGRlck9wdGlvbnMsIFVzZUNyZWF0ZUZvbGRlclByb3BzIH0gZnJvbSAnLi91c2VDcmVhdGVGb2xkZXIudHlwZXMnO1xuXG4vKlxuICBDcmVhdGUgU2VjdXJlIERvY3VtZW50IEZvbGRlciBSZWFjdCBob29rLlxuICBDbGllbnQgd2lsbCBiZSBwYXNzZWQgdGhyb3VnaCBjb250ZXh0IGJ5IGBTZWN1cmVEb2N1bWVudHNQcm92aWRlcmAuXG4gIE9wdGlvbmFsbHksIGNsaWVudCBjYW4gYmUgcGFzc2VkIHRocm91Z2ggb3B0aW9ucy5cbiovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VDcmVhdGVGb2xkZXIob3B0aW9uczogVXNlQ3JlYXRlRm9sZGVyT3B0aW9ucyA9IHt9KTogVXNlQ3JlYXRlRm9sZGVyUHJvcHMge1xuICBjb25zdCB7IGNsaWVudCB9ID0gdXNlQ29udGV4dChTZWN1cmVEb2N1bWVudHNQcm92aWRlci5Db250ZXh0KSB8fCBvcHRpb25zLmNsaWVudDtcbiAgaWYgKCFjbGllbnQpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ2NsaWVudCBub3QgZm91bmQgZm9yIGhvb2sgYHVzZUNyZWF0ZUZvbGRlcmAnKTtcbiAgfVxuXG4gIGNvbnN0IFtsb2FkaW5nLCBzZXRMb2FkaW5nXSA9IHVzZVN0YXRlKGZhbHNlKTtcbiAgY29uc3QgW2Vycm9yLCBzZXRFcnJvcl0gPSB1c2VTdGF0ZTxFcnJvcj4oKTtcblxuICBjb25zdCBjcmVhdGVGb2xkZXIgPSBhc3luYyAocGF0aDogc3RyaW5nKTogUHJvbWlzZTxDcmVhdGVGb2xkZXJPdXRwdXQ+ID0+XG4gICAgUHJvbWlzZS5yZXNvbHZlKFxuICAgICAgbmV3IFByb21pc2UoKHJlcywgcmVqKSA9PiB7XG4gICAgICAgIHNldExvYWRpbmcodHJ1ZSk7XG4gICAgICAgIGNsaWVudFxuICAgICAgICAgIC5jcmVhdGVGb2xkZXIoeyBwYXRoIH0pXG4gICAgICAgICAgLnRoZW4oKHJlc3A6IENyZWF0ZUZvbGRlck91dHB1dCkgPT4ge1xuICAgICAgICAgICAgb3B0aW9ucy5vbkNvbXBsZXRlZD8uKHJlc3ApO1xuICAgICAgICAgICAgcmVzKHJlc3ApO1xuICAgICAgICAgIH0pXG4gICAgICAgICAgLmNhdGNoKChlcnI6IEVycm9yKSA9PiB7XG4gICAgICAgICAgICBzZXRFcnJvcihlcnIpO1xuICAgICAgICAgICAgb3B0aW9ucy5vbkVycm9yPy4oZXJyKTtcbiAgICAgICAgICAgIHJlaihlcnIpO1xuICAgICAgICAgIH0pXG4gICAgICAgICAgLmZpbmFsbHkoKCkgPT4gc2V0TG9hZGluZyhmYWxzZSkpO1xuICAgICAgfSksXG4gICAgKTtcblxuICByZXR1cm4gW2NyZWF0ZUZvbGRlciwgeyBjbGllbnQsIGVycm9yLCBsb2FkaW5nIH1dO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useCreateFolder/useCreateFolder.js
// module id = 1800
// module chunks = 0